module.exports = __webpack_public_path__ + "static/media/Stillworking.05734cd0.jpg";